import './folder-controls.sass';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { I18n } from 'react-redux-i18n';

import request from 'actions/request';

class FolderControls extends Component {
  constructor (props) {
    super (props);

    this.state = {
      isFormHidden: true,
      name: props.folderInfo.name
    };
  }

  handleClickTrash () {
    if (confirm(I18n.t('tracksTree.folderControls.confirm'))) {
      this.props.request(
        ['folder', 'delete'],
        'delete',
        'FOLDER',
        { id: this.props.folderInfo.id * -1 }
      ).catch(function () {});
    }
  }

  handleClickRename () {
    if (this.state.isFormHidden === true) {
      this.resize ();
      this.setState({
        isFormHidden: false
      });
    } else if ((this.state.isFormHidden === false)
      && (this.input && this.input.value.length >= 3)) {
      this.setState({
        isFormHidden: true
      });

      this.props.request(
        ['folder', 'rename'],
        'put',
        'FOLDER_RENAME',
        {
          id: this.props.folderInfo.id * -1,
          name: this.state.name
        }
      ).catch(function () {});
    }
  }

  handleSubmit (event) {
    this.setState({
      isFormHidden: true
    });

    this.props.request(
      ['folder', 'rename'],
      'put',
      'FOLDER_RENAME',
      {
        id: this.props.folderInfo.id * -1,
        name: this.state.name
      }
    ).catch(function () {});

    event.preventDefault();
    return false;
  }

  handleChange () {
    this.setState({
      name: this.input.value
    });
  }

  resize () {
    function findAncestor (el, cls) {
      while ((el = el.parentElement) && !el.classList.contains(cls));
      return el;
    }

    let row = findAncestor(this.form, 'rst__rowContents')

    if (row) {
      this.form.style.width = row.clientWidth - 55 + 'px';
    }
  }

  render () {
    return (
      <div className='tracks-tree-folder-controls'>
        <form ref={ (form) => { this.form = form }}
          className={
            'tracks-tree-folder-controls__form '
            + (this.state.isFormHidden ? 'is-hidden' : '')
          }
          onSubmit={ this.handleSubmit.bind(this) }
        >
          <input className='form-control' type='text'
            value={ this.state.name }
            ref={ (input) => { this.input = input }}
            onChange={ this.handleChange.bind(this) }
          />
        </form>
        <span
          className={ 'tracks-tree-folder-controls__glyphicon '
            + 'glyphicon '
            + (this.state.isFormHidden
              ? 'glyphicon-pencil' : 'glyphicon-floppy-disk')
          }
          onClick={ this.handleClickRename.bind(this) }
        >
        </span>
        <span
          className={
            'tracks-tree-folder-controls__glyphicon '
            + 'tracks-tree-folder-controls__glyphicon-danger '
            + 'glyphicon glyphicon-trash'
          }
          onClick={ this.handleClickTrash.bind(this) }
        >
        </span>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    request: bindActionCreators(request, dispatch)
  }
}

export default connect(() => { return {}; }, mapDispatchToProps)(FolderControls);
